<template>
  <div id="app" style="position: relative">
    <pageHeader :isScrolling="isScrolling"></pageHeader>
    <router-view style="width: 100%" />
    <pageFooter></pageFooter>
  </div>
</template>

<script>
import pageHeader from './views/pageHeader.vue';
import pageFooter from './views/pageFooter.vue';
export default {
  components: {
    pageHeader,
    pageFooter,
  },
  data() {
    return {
      isScrolling: false,
      screenWidth: 0,
      scale: 1,
      container: null,
      fixedElement: null,
    };
  },
  watch: {
    // 监听路由变化
    $route(to, from) {
      document.documentElement.scrollTop = 0;
      this.handleResize();
    },
    screenWidth: {
      handler(newValue, oldValue) {
        if (newValue < 1480) {
          setTimeout(() => {
            this.useScale(newValue);
          }, 200);
        }
      },
    },
  },
  created() {
    const userAgent = window.navigator.userAgent;
    if (/Mobile|Android|iPhone|iPod|iPad|Windows Phone/i.test(userAgent)) {
      this.$store.commit('setAgent', 'MOBILE');
    } else {
      this.$store.commit('setAgent', 'PC');
    }
  },
  mounted() {
    this.screenWidth = window.innerWidth;
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    scrollHandler() {
      if (this.fixedElement) {
        this.fixedElement.style.marginTop = `${window.scrollY / this.scale}px`;
      }
    },
    useScale(width) {
      this.container = document.querySelector('body');
      this.fixedElement = document.querySelector('.page-header');
      const sWidth = window.innerWidth;
      const targetWidth = 1480;
      this.scale = sWidth / targetWidth;
      if (width > 1000 && sWidth <= targetWidth) {
        this.container.style.transform = `scale(${this.scale})`;
        this.container.classList.add('container-scale');

        let innerBoxHeight = document.getElementById('app').offsetHeight;
        this.container.style.height = `${innerBoxHeight}px`;
        window.addEventListener('scroll', this.scrollHandler);
      } else {
        this.restoreDefault();
      }
    },
    restoreDefault() {
      if (this.fixedElement) {
        this.fixedElement.style.marginTop = '0px';
      }
      if (this.container) {
        this.container.style.transform = 'none';
        this.container.style.height = '100%';
        this.container.style.width = '100%';
        this.container.classList.remove('container-scale');
      }
      window.removeEventListener('scroll', this.scrollHandler);
    },
  },
};
</script>

<style lang="scss">
@import './assets/css/public.scss';

* {
  margin: 0;
  padding: 0;

  ::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
  }
}
div,
header,
footer,
section {
  box-sizing: border-box;
}
ul,
li,
ol {
  list-style: none;
}

.container-scale {
  transform-origin: top left;
  min-width: 1480px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
</style>
